// extracted by mini-css-extract-plugin
export default {"wrapper":"OriginDestinationHorizontal-module__wrapper___LnzMX","wrapperVertical":"OriginDestinationHorizontal-module__wrapperVertical___b5DTh"};